export const badgeExists = (badge) => {
  if (!badge || badge === 'null' || badge === '{}') {
    return false;
  }
  return true;
};
